// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router'
import store from "./store";
import {sync} from 'vuex-router-sync';
import filters from "./filters/index";
import './icons';
import './libs/directives/DialogDirectives.js'
import './libs/directives/TableDirective.js'
import './libs/directives/antiShake.js'
import './libs/directives/throttling.js'

import './assets/menu-icon-font/iconfont.css';
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import GetUrl from './libs/utils/GetUrl';
import {ENV} from "./config/app";
//xml格式 页面代码高亮文件引入 
import hljs from 'highlight.js'
//样式文件，我选了a11y-light.css，可选择文件里其他高亮样式css
import 'highlight.js/styles/a11y-light.css'

Object.keys(filters).map(value => {
  Vue.filter(value, filters[value]);
})
Vue.directive('has', {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})
Vue.prototype.$_has = function(value) {
  let isExist = false
  var btnpermsStr = JSON.parse(sessionStorage.getItem('btnPerms'))
  if (
    btnpermsStr === undefined ||
    btnpermsStr == null ||
    btnpermsStr.length == 0
  ) {
    return false
  }
  for (let i = 0; i < btnpermsStr.length; i++) {
    if (btnpermsStr[i] == value) {
      // 若在按钮中定义的权限字段能在后端返回的权限数组中能找到，则该按钮可显示
      isExist = true
      break
    }
  }
  
  return isExist
}

/*Vue的全局配置*/
const isDebugger = ENV.NODE_ENV === 'development';
Vue.config.silent = isDebugger;
Vue.config.devtools = isDebugger;
Vue.config.productionTip = isDebugger;

/*在Vue对象上添加原型方法*/
Vue.prototype.$GetUrl = GetUrl;
Vue.prototype.$ENV = ENV;

/*引入插件*/
Vue.use(ElementUI,{ size: 'mini' });

/*注册全局事件对象*/
window.eventBus = new Vue();

Vue.directive('highlight',function (el) {
  let blocks = el.querySelectorAll('pre code');
      blocks.forEach((block)=>{
      hljs.highlightBlock(block)
  })
})

/*把 vue-router 当前的 $route 同步为 vuex 状态的一部分*/
sync(store, router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js